import React from 'react';

export const AddIcon = (props) => {
  // console.log('Add', props);
  return (
    <svg height={props.size} width={props.size} version="1.1" x="0px" y="0px" viewBox="0 0 100 100">
      <g transform="translate(0,-952.36218)">
        <path d="m 50,966.36218 c -1.6568,0 -3,1.3432 -3,3 l 0,30.0001 -30,0 c -1.6569,0 -3,1.34312 -3,3.00002 0,1.6568 1.3431,3 3,3 l 30,0 0,29.9999 c 0,1.6568 1.3432,3 3,3 1.6569,0 3,-1.3432 3,-3 l 0,-29.9999 30,0 c 1.6569,0 3,-1.3432 3,-3 0,-1.6569 -1.3431,-3.00002 -3,-3.00002 l -30,0 0,-30.0001 c 0,-1.6568 -1.3431,-3 -3,-3 z" fill="inherit" fillOpacity="1" stroke="none" marker="none" visibility="visible" display="inline" overflow="visible">
        </path>
      </g>
    </svg>

  )
}

// <svg height={props.size} width={props.size} fill={props.color} xmlns="http://purl.org/dc/elements/1.1/" xmlns="http://creativecommons.org/ns#" xmlns="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns="http://www.inkscape.org/namespaces/inkscape" version="1.1" x="0px" y="0px" viewBox="0 0 100 100">

// <path style="text-indent:0;text-transform:none;direction:ltr;block-progression:tb;baseline-shift:baseline;color:#000000;enable-background:accumulate;" d="m 50,966.36218 c -1.6568,0 -3,1.3432 -3,3 l 0,30.0001 -30,0 c -1.6569,0 -3,1.34312 -3,3.00002 0,1.6568 1.3431,3 3,3 l 30,0 0,29.9999 c 0,1.6568 1.3432,3 3,3 1.6569,0 3,-1.3432 3,-3 l 0,-29.9999 30,0 c 1.6569,0 3,-1.3432 3,-3 0,-1.6569 -1.3431,-3.00002 -3,-3.00002 l -30,0 0,-30.0001 c 0,-1.6568 -1.3431,-3 -3,-3 z" fill="inherit" fillOpacity="1" stroke="none" marker="none" visibility="visible" display="inline" overflow="visible">



// WEBPACK FOOTER //
// ./client/src/img/addIcon.js